
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M-3-3h24v24H-3z"}}),_c('path',{attrs:{"fill":"currentColor","d":"M10.5 1A1.5 1.5 0 0112 2.5v10a1.5 1.5 0 01-3 0v-10A1.5 1.5 0 0110.5 1zm-5 5A1.5 1.5 0 017 7.5v5a1.5 1.5 0 01-3 0v-5A1.5 1.5 0 015.5 6zM2 16h15a1 1 0 010 2H1a1 1 0 01-1-1V1a1 1 0 112 0v15zm13.5-8A1.5 1.5 0 0117 9.5v3a1.5 1.5 0 01-3 0v-3A1.5 1.5 0 0115.5 8z"}})])])
          )
        }
      }
    